/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

export const fetchEmailAddressFromId = async (wcEnv = {}, jwtToken, indivId) => {
    const env = wcEnv;

    env.rootUri = '/giftlist';

    const resourcePage = `/email?indiv_id=${indivId}`;

    return restClient.getFacade(env, resourcePage, jwtToken).then((response) => response);
};

export default {};
